{
  "projects": "Projects",
  "reports": "Reports",
  "help": "Help & Support",
  "survey": "UX Test: Survey",
  "profile": "Your profile",
  "settings": "Settings",
  "recommendUs": "Recommend us!",
  "signOut": "Sign out",
  "noMessages": "No notifications"
}
